// extracted by mini-css-extract-plugin
export default {"right-side":"RightSide_right-side__lKRsB","right-side--panel":"RightSide_right-side--panel__9I-oL"};